
import ContactOne from '@/components/Contacts/ContactOne.vue'
import {
  buildPageHead,
  buildAnalyticsMeta,
  buildHeadScripts,
} from '@/helpers/pageSeo'

export default {
  components: {
    ContactOne,
  },
  head() {
    const pageTitle = `${this.$custom$t('nav.contact')} | ${this.$store.state.settings.title}`
    const { title, meta, link } = buildPageHead(this, {
      title: pageTitle,
      description: this.$custom$t('seo.pages.contact.description'),
    })
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title,
      meta: [...meta, ...buildAnalyticsMeta(this)],
      link,
      script: buildHeadScripts(this),
      __dangerouslyDisableSanitizers: ['script'],
    }
  },
}
